import { ConversationRow, MessageRow } from '../../../types/supabase';
import { useAppSelector } from '../../hooks/reduxToolkit';

interface ConversationSubtitleProps {
  conversation: ConversationRow;
  messages: MessageRow[];
}

export function ConversationSubtitle({ conversation, messages }: ConversationSubtitleProps) {
  const expense = useAppSelector(s => conversation?.topic_ref_id ? s.expenses.expenses.find(e => e.id === conversation?.topic_ref_id) : null);

  const getDateRange = () => {
    if (messages.length === 0) return null;
    
    const sortedMessages = [...messages].sort((a, b) => 
      new Date(a.created_at).getTime() - new Date(b.created_at).getTime()
    );
    
    const startDate = new Date(sortedMessages[0].created_at);
    const endDate = new Date(sortedMessages[sortedMessages.length - 1].created_at);
    
    // If conversation started and ended on the same day
    if (startDate.toDateString() === endDate.toDateString()) {
      return `Started ${startDate.toLocaleDateString()}`;
    }
    
    return `${startDate.toLocaleDateString()} - ${endDate.toLocaleDateString()}`;
  };

  const getSubtitleText = () => {
    const dateRange = getDateRange();
    const baseParts = [];
    
    // Add date range first
    if (dateRange) {
      baseParts.push(dateRange);
    }
    
    // Then add the conversation purpose
    switch (conversation.topic_type) {
      case 'itemized-bill':
        if (expense) {
          const expenseDate = expense.date ? new Date(expense.date).toLocaleDateString() : 'Unknown date';
          const expenseAmount = expense.listedAmount || 'Unknown amount';
          baseParts.push(`Requesting itemized bill for \$${expenseAmount} on ${expenseDate}`);
        } else {
          baseParts.push('Requesting itemized bill for expense');
        }
        break;
      default:
        baseParts.push('General conversation');
    }
    
    return baseParts;
  };

  const getIcon = () => {
    switch (conversation.topic_type) {
      case 'itemized-bill':
        return 'receipt_long';
      default:
        return null;
    }
  };

  const subtitleParts = getSubtitleText();
  const icon = getIcon();

  if (!subtitleParts || subtitleParts.length === 0) {
    return null;
  }

  return (
    <div className="conversation-subtitle text-muted mb-3">
      {icon && (
        <i className="material-icons me-2" style={{ fontSize: '1.1rem', verticalAlign: 'middle' }}>
          {icon}
        </i>
      )}
      <span>
        {subtitleParts.map((part, index) => (
          <span key={index}>
            {part}
            {index < subtitleParts.length - 1 && <br />}
          </span>
        ))}
      </span>
    </div>
  );
}